import { useQuery } from '@apollo/client';
import { GET_PDP_KEY_SELLING_POINTS } from 'mocks/queries';
import usePdpId from 'components/consumer/PDP/state/context/usePdpId';

const usePDPKeySellingPoints = () => {
  const pdpId = usePdpId();

  const { loading, error, data } = useQuery(GET_PDP_KEY_SELLING_POINTS, {
    variables: { id: parseInt(pdpId, 10) },
    skip: !pdpId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    loading,
    error,
    data: data?.getPDPKeySellingPoints || [],
  };
};

export default usePDPKeySellingPoints;
